'use client';

import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { LISTING_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER, LISTING_PAGE_PREFIXED_CALLCENTER_TELEPHONE_NUMBER } from '@/costants';

// Test values (when feature flag is 'test') (important-comment)
const TEST_LISTING_PAGE_PREFIXED_CALLCENTER_TELEPHONE_NUMBER = '+390281127928';
const TEST_LISTING_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER = '02 81127928';

/**
 * React hook for getting call center phone numbers with feature flag support
 * This hook will update when feature flags change
 */
export const useCallCenterPhoneNumbers = () => {
  const posthog = usePostHog();
  const featureFlagValue = posthog.getFeatureFlag('listing_page_callcenter_phone_number');

  const { prefixedNumber, formattedNumber } = useMemo(() => {
    const isAICallCenterOn = featureFlagValue === 'test';
    // Use the utility functions to get the current values based on feature flags
    return {
      prefixedNumber: isAICallCenterOn
        ? TEST_LISTING_PAGE_PREFIXED_CALLCENTER_TELEPHONE_NUMBER
        : LISTING_PAGE_PREFIXED_CALLCENTER_TELEPHONE_NUMBER,
      formattedNumber: isAICallCenterOn
        ? TEST_LISTING_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER
        : LISTING_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER,
    };
  }, [featureFlagValue]);

  return { prefixedNumber, formattedNumber };
};
